module["exports"] = [
  "br",
  "com",
  "biz",
  "info",
  "name",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/internet/domain_suffix.js
// module id = 1489
// module chunks = 0